const i = () => {
  const n = {}, t = {};
  return {
    register: (o, r) => {
      o in n || (n[o] = r), o in t && t[o].forEach(
        (e) => e(r)
      );
    },
    locate: (o, r = 5e3) => o in n ? Promise.resolve(n[o]) : new Promise((s, c) => {
      setTimeout(c, r), t[o] = t[o] || /* @__PURE__ */ new Set(), t[o].add(s);
    })
  };
};
globalThis.$$frontendServiceLocator = globalThis.$$frontendServiceLocator || i();
const d = globalThis.$$frontendServiceLocator;
export {
  i as createServiceLocator,
  d as default
};
